import { render } from "./TextExtended.vue?vue&type=template&id=187f8d24"
import script from "./TextExtended.vue?vue&type=script&lang=js"
export * from "./TextExtended.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__